import React, { useContext, useMemo } from "react";
import { StoreContext } from "../../../Library/contexts";
import { Select } from "../../Atoms";

const ClientPicker = () => {
  const { constants, filters, setFilters } = useContext(StoreContext);
  const url = new URL(window.location);
  url.searchParams.set("client", filters.client);
  window.history.replaceState(window.history.state, "", url);

  const setClients = (cl) => {
    setFilters({ ...filters, client: cl })
  };

  const { options } = useMemo(() => {
    const options = [];

    constants.clients.forEach((client) => {
      options.push({ value: client.idx, label: `${client.cName}` });
    });

    return { options };
  }, [ constants ]);

  return (
    <Select defaultValue={filters.client} onChange={setClients} options={options} width={180} />
  );
};

export default ClientPicker;
